import { useTranslation } from "react-i18next";

import ActionMenu from "../../../common/components/functional/actionMenu/ActionMenu";
import { AnchorElement } from "../../../common/types/commonTypes";
import { MenuItemOption } from "../../../common/components/functional/actionMenu/types";

type Props = {
  id: string;
  anchorEl: AnchorElement;
  onClose: () => void;
  onSelect: (paySalary: boolean) => void;
};

export const CancelPayMenu = ({ id, anchorEl, onClose, onSelect }: Props) => {
  const { t } = useTranslation("order");

  const menuItems: MenuItemOption[] = [
    {
      key: "notPaid",
      label: t("notPaid"),
      action: () => onSelect(false),
    },
    {
      key: "paidButNotBilled",
      label: t("paidButNotBilled"),
      action: () => onSelect(true),
    },
  ];

  return (
    <ActionMenu
      id={id}
      anchorEl={anchorEl}
      onClose={onClose}
      menuItems={menuItems}
    />
  );
};
